import { ModuleLocalization } from '@ocean/configs/dist/localization'
import { BASE_NAMESPACE } from 'config/localization/constants'
import en from './en'

export const namespace = `${BASE_NAMESPACE}_VIRTUAL_CLASSROOM`

export const localization: ModuleLocalization = { namespace, en }
